import React, {Component} from "react";
import {withTranslation} from "react-i18next";
import {createTheme, ThemeProvider} from "@mui/material";
import '../style/form.css';
import ProximusTextField from "./ProximusTextField";
import LegalDisclaimerComponent from "./LegalDisclaimerComponent";
import LoadingComponent from "./LoadingComponent";
import ButtonComponent from "./ButtonComponent";
import FormErrorComponent from "./FormErrorComponent";

class FormComponent extends Component {

    constructor(props) {
        super(props);

        this.state = {
            firstName: '',
            lastName: '',
            companyName: '',
            street: '',
            number: '',
            boxNumber: '',
            zipCode: '',
            city: '',
            addressExtra: '',
            emailAddress: '',
            phoneNumber: ''
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props !== prevProps) {
            this.setState({
                invalidPhoneNumber: this.props.invalidPhoneNumber,
                invalidEmailAddress: this.props.invalidEmailAddress
            })
        }
    }

    validateRequiredStateEntry = (key, expectInt) => {
        let valid = this.state[key];
        if (expectInt) {
            valid = valid && !isNaN(parseFloat(this.state[key])) && isFinite(this.state[key]);
        }
        this.setState({
            [`${key}Missing`]: !valid
        });
        return valid;
    }

    onSubmit = () => {
        let validationError = false;
        this.setState({nameMissing: false});
        if (this.props.formTemplate.nameEnabled && !this.state.firstName && !this.state.lastName) {
            validationError = true;
            this.setState({nameMissing: true, validationError: true});
        }
        if (this.props.formTemplate.addressEnabled) {
            validationError = !this.validateRequiredStateEntry("street") || validationError;
            validationError = !this.validateRequiredStateEntry("number") || validationError;
            validationError = !this.validateRequiredStateEntry("zipCode", true) || validationError;
            validationError = !this.validateRequiredStateEntry("city") || validationError;
        }
        if (this.props.formTemplate.phoneNumberEnabled) {
            const isPhoneNumberPresent = this.validateRequiredStateEntry("phoneNumber");
            validationError = !isPhoneNumberPresent || validationError;
            if (isPhoneNumberPresent) {
                const invalidPhoneNumber = !/^((\+|00)32\s?|0)4[6789]\d((\s?\d{2}){3}|(\s?\d{3}){2})$/.test(this.state.phoneNumber);
                this.setState({invalidPhoneNumber: invalidPhoneNumber});
                validationError = invalidPhoneNumber || validationError;
            }
        }
        if (this.props.formTemplate.emailEnabled) {
            const isEmailPresent = this.validateRequiredStateEntry("emailAddress");
            validationError = !isEmailPresent || validationError;
            if (isEmailPresent) {
                const invalidEmailAddress = !/([^.@]+)(\.[^.@]+)*@([^.@]+\.)*([^.@]+)/.test(this.state.emailAddress);
                this.setState({invalidEmailAddress: invalidEmailAddress});
                validationError = invalidEmailAddress || validationError;
            }
        }
        this.setState({validationError: validationError});
        if (!validationError) {
            this.props.onSubmitFormData({
                firstName: this.state.firstName,
                lastName: this.state.lastName,
                companyName: this.state.companyName,
                street: this.state.street,
                number: parseInt(this.state.number),
                boxNumber: this.state.boxNumber,
                addressExtra: this.state.addressExtra,
                city: this.state.city,
                zipCode: this.state.zipCode ? this.state.zipCode : 0,
                phoneNumber: this.state.phoneNumber,
                emailAddress: this.state.emailAddress
            });
        }
    }

    render() {
        const theme = createTheme({
            palette: {
                primary: {
                    main: '#5c2d91'
                }
            },
            typography: {
                fontFamily: 'Proximus',
                fontSize: 22
            }
        });

        const InputProps = {disableUnderline: true};

        return <ThemeProvider theme={theme}>
            <p>{this.props.formTemplate.description}</p>
            <div className="form-input-container">
                <div>
                    <h1 className="form-subtitle">{this.props.t('form.name.subTitle')}</h1>
                    <ProximusTextField required={this.props.formTemplate.nameEnabled}
                                       id="firstName"
                                       label={this.props.t('form.name.firstName')}
                                       variant="filled"
                                       value={this.state.firstName}
                                       onChange={(e) => this.setState({firstName: e.target.value})}
                                       InputProps={InputProps}
                                       error={this.state.nameMissing}
                                       helperText={this.state.nameMissing ? this.props.t('form.name.required') : null}/>
                    <ProximusTextField required={this.props.formTemplate.nameEnabled}
                                       id="lastName"
                                       label={this.props.t('form.name.lastName')}
                                       variant="filled"
                                       value={this.state.lastName}
                                       onChange={(e) => this.setState({lastName: e.target.value})}
                                       InputProps={InputProps}
                                       error={this.state.nameMissing}
                                       helperText={this.state.nameMissing ? this.props.t('form.name.required') : null}/>
                    <ProximusTextField id="companyName"
                                       label={this.props.t('form.name.companyName')}
                                       variant="filled"
                                       value={this.state.companyName}
                                       onChange={(e) => this.setState({companyName: e.target.value})}
                                       InputProps={InputProps}/>
                </div>
                {this.props.formTemplate.addressEnabled && <div>
                    <h1 className="form-subtitle">{this.props.t('form.address.subTitle')}</h1>
                    <ProximusTextField required
                                       id="street"
                                       label={this.props.t('form.address.street')}
                                       variant="filled"
                                       value={this.state.street}
                                       onChange={(e) => this.setState({street: e.target.value})}
                                       InputProps={InputProps}
                                       error={this.state.streetMissing}
                                       helperText={this.state.streetMissing ? this.props.t('form.requiredField') : null}/>
                    <ProximusTextField required
                                       id="number"
                                       className="form-field-half"
                                       label={this.props.t('form.address.number')}
                                       variant="filled"
                                       value={this.state.number}
                                       onChange={(e) => this.setState({number: e.target.value})}
                                       InputProps={InputProps}
                                       error={this.state.numberMissing}
                                       helperText={this.state.numberMissing ? this.props.t('form.requiredField') : null}/>
                    <ProximusTextField id="boxNumber"
                                       className="form-field-half"
                                       label={this.props.t('form.address.box')}
                                       variant="filled"
                                       value={this.state.boxNumber}
                                       onChange={(e) => this.setState({boxNumber: e.target.value})}
                                       InputProps={{disableUnderline: true}}/>
                    <ProximusTextField required
                                       id="zipCode"
                                       label={this.props.t('form.address.zip')}
                                       type="number"
                                       variant="filled"
                                       value={this.state.zipCode}
                                       onChange={(e) => this.setState({zipCode: e.target.value})}
                                       InputProps={InputProps}
                                       error={this.state.zipCodeMissing}
                                       helperText={this.state.zipCodeMissing ? this.props.t('form.requiredNumericField') : null}/>
                    <ProximusTextField required
                                       id="city"
                                       label={this.props.t('form.address.city')}
                                       variant="filled"
                                       value={this.state.city}
                                       onChange={(e) => this.setState({city: e.target.value})}
                                       InputProps={InputProps}
                                       error={this.state.cityMissing}
                                       helperText={this.state.cityMissing ? this.props.t('form.requiredField') : null}/>
                    <ProximusTextField id="addressExtra"
                                       label={this.props.t('form.address.extra')}
                                       variant="filled"
                                       value={this.state.addressExtra}
                                       onChange={(e) => this.setState({addressExtra: e.target.value})}
                                       InputProps={InputProps}/>
                </div>}
                {(this.props.formTemplate.phoneNumberEnabled || this.props.formTemplate.emailEnabled) && <div>
                    <h1 className="form-subtitle">{this.props.t('form.contact.subTitle')}</h1>
                    {this.props.formTemplate.phoneNumberEnabled &&
                        <ProximusTextField required
                                           id="number"
                                           type="tel"
                                           label={this.props.t('form.contact.number')}
                                           variant="filled"
                                           value={this.state.phoneNumber}
                                           onChange={e => {
                                               if (!e.nativeEvent.data || (/^\+?[\d\s]*$/.test(e.nativeEvent.data)))
                                                   this.setState({phoneNumber: e.target.value})
                                           }}
                                           InputProps={InputProps}
                                           error={this.state.invalidPhoneNumber || this.state.phoneNumberMissing}
                                           helperText={(this.state.invalidPhoneNumber || this.state.phoneNumberMissing) ? this.props.t('form.contact.invalidNumber') : null}/>}
                    {this.props.formTemplate.emailEnabled &&
                        <ProximusTextField required
                                           id="email"
                                           type="email"
                                           label={this.props.t('form.contact.email')}
                                           variant="filled"
                                           value={this.state.emailAddress}
                                           onChange={e => {
                                               this.setState({emailAddress: e.target.value})
                                           }}
                                           InputProps={InputProps}
                                           error={this.state.invalidEmailAddress || this.state.emailAddressMissing}
                                           helperText={(this.state.invalidEmailAddress || this.state.emailAddressMissing) ? this.props.t('form.contact.invalidEmailAddress') : null}/>}
                </div>}
            </div>
            <LegalDisclaimerComponent/>
            {(this.props.missingFields || this.state.validationError || this.state.invalidPhoneNumber || this.state.invalidEmailAddress) &&
                <FormErrorComponent messageKey="form.missingFields"/>}
            {this.props.submitting ? <LoadingComponent/> :
                <ButtonComponent onButtonClick={() => this.onSubmit()}
                                 textKey={'form.submit'}
                                 className="confirm-btn box-btn"/>
            }
        </ThemeProvider>
    }
}

export default withTranslation()(FormComponent)